<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <!-- 顶部圆形图标 -->
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="商户端" class="logo-img" />
        <h1 class="logo-title" v-if="!isCollapse">小红薯商户端</h1>
      </div>

      <!-- 左侧导航 -->
      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#bfcbd9"
        active-text-color="#409EFF" router :collapse="isCollapse">
        <!-- 用户管理 -->
        <el-sub-menu index="/user">
          <template #title>
            <el-icon>
              <User />
            </el-icon>
            <span>用户管理</span>
          </template>
          <el-menu-item index="/user/info">
            <el-icon>
              <UserFilled />
            </el-icon>
            <span>用户信息</span>
          </el-menu-item>
          <el-menu-item index="/user/UserAddress">
            <el-icon>
              <Location />
            </el-icon>
            <span>地址管理</span>
          </el-menu-item>
          <el-menu-item index="/user/coupon">
            <el-icon>
              <Ticket />
            </el-icon>
            <span>优惠券明细</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 门店管理 -->
        <el-menu-item index="/store">
          <el-icon>
            <Shop />
          </el-icon>
          <span>门店管理</span>
        </el-menu-item>

        <!-- 订单中心 -->
        <el-menu-item index="/order">
          <el-icon>
            <Document />
          </el-icon>
          <span>订单中心</span>
        </el-menu-item>

        <!-- 商品管理 -->
        <el-sub-menu index="/product">
          <template #title>
            <el-icon>
              <Goods />
            </el-icon>
            <span>商品管理</span>
          </template>
          <el-menu-item index="/product/category">
            <el-icon>
              <Menu />
            </el-icon>
            <span>商品分类</span>
          </el-menu-item>
          <el-menu-item index="/product/add">
            <el-icon>
              <CirclePlus />
            </el-icon>
            <span>添加商品</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 其他菜单项 -->
        <el-menu-item index="/coupon">
          <el-icon>
            <Discount />
          </el-icon>
          <span>优惠券</span>
        </el-menu-item>
        <el-menu-item index="/mini">
          <el-icon>
            <Platform />
          </el-icon>
          <span>小程序</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">
        <div class="nav-left">
          <img @click="handleNavClick('distribution')" src="@/assets/distribution-center.png" alt="分销中心"
            class="nav-img" />
          <img @click="handleNavClick('discount')" src="@/assets/discount-package.png" alt="优惠套餐" class="nav-img" />
        </div>
        <div class="nav-center">
          <span class="points-text">点数: {{ points.toFixed(1) }}</span>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="30" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon">
                <ArrowDown />
              </el-icon>

            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon>
                    <Edit />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="showPasswordDialog"
    title="修改密码"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input 
          v-model="form.oldPwd" 
          type="password" 
          placeholder="请输入旧密码"
          show-password
        />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input
          v-model="form.newPwd"
          type="password"
          placeholder="请输入新密码"
          show-password
        />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
          v-model="form.confirmPwd"
          type="password"
          placeholder="请再次输入新密码"
          show-password
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showPasswordDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>


</template>

<script>
import {
  User,
  UserFilled,
  Shop,
  Document,
  Goods,
  Menu,
  CirclePlus,
  Discount,
  Platform,
  Ticket,
  Edit,
  ArrowDown,
  SwitchButton,
  Location
} from '@element-plus/icons-vue'
import { ref, computed, onMounted,reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'

export default {
  name: 'MainLayout',
  components: {
    User,
    UserFilled,
    Shop,
    Document,
    Goods,
    Menu,
    CirclePlus,
    Discount,
    Platform,
    Ticket,
    Edit,
    ArrowDown,
    SwitchButton,
    Location
  },
  setup() {
    const router = useRouter()
    // 从Cookies获取用户信息
    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)
    const points = ref(0) // 初始化为0

    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(account)

    const activeMenu = computed(() => {
      const route = router.currentRoute.value
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })
    const showPasswordDialog = ref(false)
  const form = reactive({
    oldPwd: '',
    newPwd: '',
    confirmPwd: ''
  })

    // 加载点数数据
    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account: account
        })

        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
        } else {
          ElMessage.error('点数加载失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        ElMessage.error('接口请求失败: ' + error.message)
      }
    }

  // 修改密码方法
  const submitPassword = async () => {
    // 前端验证
    if (!form.oldPwd) {
      ElMessage.error('请输入旧密码')
      return
    }
    if (!form.newPwd) {
      ElMessage.error('请输入新密码')
      return
    }
    if (form.newPwd !== form.confirmPwd) {
      ElMessage.error('两次输入的新密码不一致')
      return
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
        action: 'update_password',
        account: account,
        old_password: form.oldPwd,
        new_password: form.newPwd
      })

      if (response.data.success) {
        ElMessage.success('密码修改成功，请重新登录')
        // 清除登录状态
        Cookies.remove('user_token')
        router.push('/login')
      } else {
        ElMessage.error(response.data.message || '密码修改失败')
      }
    } catch (error) {
      ElMessage.error(error.response?.data?.message || '请求失败')
    } finally {
      showPasswordDialog.value = false
    }
  }

  // 修改密码按钮点击事件
  const handleModifyPassword = () => {
    // 重置表单
    Object.assign(form, {
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })
    showPasswordDialog.value = true
  }
    onMounted(() => {
      loadPoints()
    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      userAvatar,
      username,
      activeMenu,

      handleLogout,
      handleNavClick,
      showPasswordDialog,
    form,
    submitPassword,
    handleModifyPassword
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  display: flex;

  background: linear-gradient(135deg, #f8f9fc 0%, #eef1f6 100%);
}
.el-form-item {
  margin-bottom: 20px;
}
.el-input {
  width: 100%;
}
.sidebar {
  width: 220px;
  background: linear-gradient(195deg, #1a2847 0%, #2a3f5f 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .logo-container {
    padding: 24px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    text-align: center;

    .logo-img {
      width: 64px;
      height: 64px;
      border: 2px solid rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      transition: all 0.3s;
    }

    .logo-title {
      margin: 12px 0 0;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
      background: linear-gradient(to right, #fff 0%, #a0b9ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: rgba(255, 255, 255, 0.05);
  padding: 12px 8px;
  height: calc(100vh - 140px);

  :deep(.el-submenu__title),
  :deep(.el-menu-item) {
    height: 48px;
    margin: 4px 0;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 20px !important;
    display: flex !important;
    align-items: center;

    .el-icon {
      font-size: 18px;
      flex-shrink: 0;
      width: 24px;
      margin-right: 11px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.08) !important;
      transform: translateX(4px);
    }


  }

  :deep(.el-sub-menu) {

    // 调整箭头图标位置
    .el-sub-menu__icon-arrow {
      right: 12px !important;
      margin-top: -7px !important;
    }

    // 保持与普通菜单项相同的文字缩进
    .el-sub-menu__title span {
      margin-left: -1px;
    }
  }

  // 统一所有菜单项的图标间距
  :deep(.el-menu-item .el-icon),
  :deep(.el-sub-menu__title .el-icon) {
    margin-right: 11px !important;
  }

  :deep(.el-menu-item)>span,
  :deep(.el-submenu__title)>span {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  :deep(.el-menu-item.is-active) {
    background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, transparent 100%) !important;
    border-left: 4px solid #409EFF;

    &::after {
      content: none;
    }
  }

    // 新增二级菜单缩进
    :deep(.el-sub-menu) {
    .el-menu-item {
      padding-left: 50px !important;  // 增加30px缩进
      position: relative;


    }

    // 保持激活状态样式
    .el-menu-item.is-active {
      padding-left: 48px !important; // 保持缩进一致性
    }
  }
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 64px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .nav-left {
    display: flex;
    gap: 16px;
    margin-right: 30px;

    .nav-img {
      height: 42px;
      padding: 8px;
      border-radius: 8px;

      transition: all 0.3s;
      cursor: pointer;

      &:hover {
        background: rgba(64, 158, 255, 0.2);
        transform: translateY(-2px);
      }
    }
  }

  .points-text {
    font-size: 16px;
    font-weight: 600;
    padding: 6px 16px;
    border-radius: 20px;
    background: linear-gradient(135deg, #f6f8ff 0%, #e9efff 100%);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    margin-right: 30px;
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 12px;
    transition: background 0.3s;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
    }

    .el-avatar {
      box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
    }

    .username {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .arrow-icon {
      margin-left: 6px;
      color: #666;
      font-size: 12px;
      transition: transform 0.3s;
    }
  }
}

.main-content-container {
  flex: 1;
  overflow-y: auto;
  background: transparent;

  .main-content {
    background: #ffffff;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
    padding: 24px;
    min-height: calc(100vh - 128px);
    border: 1px solid rgba(0, 0, 0, 0.05);
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.4);
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}
</style>